import React from "react";
import SectionShell from "../../components/sections/SectionShell";
import MoneyPayouts from "./MoneyPayouts";
import Expenses from "../Expenses";
import FinanceImports from "../finance/FinanceImports";
import PlatformFinance from "../finance/PlatformFinance";
import CRMLeaderboard from "../CRMLeaderboard";

export const MONEY_TABS = [
  { id: "payouts", label: "Payouts", icon: "💸", render: () => <MoneyPayouts />,
    description: "Platform payouts, earnings, studios, events and invoices." },
  { id: "expenses", label: "Expenses & P&L", icon: "🧾", render: () => <Expenses /> },
  { id: "imports", label: "Imports", icon: "📥", render: () => <FinanceImports />,
    description: "Upload platform sales exports and statements." },
  { id: "observations", label: "Platform observations", icon: "📊", render: () => <PlatformFinance />,
    description: "Earnings figures read from the platforms by the extension." },
  { id: "leaderboard", label: "Leaderboard", icon: "🏆", render: () => <CRMLeaderboard /> },
];

// Old tab/page names still open the combined payout workspace.
export const MONEY_TAB_ALIASES = { overview: "payouts", revenue: "payouts", finance: "observations", pnl: "expenses", "finance-imports": "imports" };

export default function MoneySection() {
  return (
    <SectionShell
      sectionId="money"
      title="Money"
      overline="EARNINGS · PAYOUTS · EXPENSES · PER CURRENCY"
      tabs={MONEY_TABS}
      aliases={MONEY_TAB_ALIASES}
    />
  );
}
